import React from 'react';

interface ProgressBarProps {
    step: number;
    total?: number;
    completed: boolean;
}
const ProgressBar = ({
    step,
    total = 3,
    completed = false,
}: ProgressBarProps) => {
    return (
        <div
            className="flex w-full h-4 rounded-full overflow-hidden bg-background-secondary"
            role="progressbar"
            aria-valuenow={step / total}
            aria-valuemin={0}
            aria-valuemax={100}>
            <div
                className="flex flex-col justify-center rounded-full overflow-hidden bg-background-brand-secondary transition-all duration-150 ease-linear w-full will-change-transform"
                style={{
                    transform: `translateX(${
                        completed
                            ? 0
                            : step === 0
                            ? '-90%'
                            : `${(100 - (step / total) * 100) * -1}%`
                    })`,
                }}
            />
        </div>
    );
};

export default ProgressBar;
